<div class="holder">
  <div class="org-selector">
    <mat-form-field>
      <mat-label>Selecione um gabinete</mat-label>
      <mat-select (selectionChange)="onOrgChange($event.value)">
        @for (org of organizationService.organizations(); track org.id) {
          <mat-option [value]="org.id">{{ org.name }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  @if (loading()) {
    <div class="loading-holder">
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  } @else {
    <div class="mat-elevation-z8">
      <table mat-table [dataSource]="dataSource" matSort>
        <ng-container matColumnDef="name">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Nome </th>
          <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
        </ng-container>

        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo </th>
          <td mat-cell *matCellDef="let row"> {{ eventTypeEnum[row.type] || row.type }} </td>
        </ng-container>

        <ng-container matColumnDef="eventsCount">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Qtd. Eventos </th>
          <td mat-cell *matCellDef="let row"> {{ row.eventsCount }} </td>
        </ng-container>

        <ng-container matColumnDef="firstDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Primeira Data </th>
          <td mat-cell *matCellDef="let row"> {{ formatDate(row.firstDate) }} </td>
        </ng-container>

        <ng-container matColumnDef="lastDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Última Data </th>
          <td mat-cell *matCellDef="let row"> {{ formatDate(row.lastDate) }} </td>
        </ng-container>

        <ng-container matColumnDef="startTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Início </th>
          <td mat-cell *matCellDef="let row"> {{ formatTime(row.startTime) }} </td>
        </ng-container>

        <ng-container matColumnDef="endTime">
          <th mat-header-cell *matHeaderCellDef mat-sort-header> Fim </th>
          <td mat-cell *matCellDef="let row"> {{ formatTime(row.endTime) }} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="7">Nenhum evento recorrente encontrado</td>
        </tr>
      </table>
      <mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 100]" aria-label="Selecione a página dos eventos"></mat-paginator>
    </div>
  }
</div>
